import { atom } from "jotai";
import { Project } from "../models/Project";

export const currentProjectAtom = atom<Project|undefined>(undefined);
